<template>
  <div class="about">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <p class="sub-title">
              Why do we exist
            </p>
            <h1 class="title">
              Our story
            </h1>
          </div>
          <p>
            Like many other innovations, our Ludimos coaching platform was also
            born out of a necessity. Maddy, our Founder, found it difficult to
            remember the feedback he received from his coaches which hindered
            his own progress. No apps and tools were available in the market
            that solved his problems.

            <br>
            <br>
            That was the <b>Eureka</b> moment where he combined both his passion
            for cricket and love for technology. He then found like minded,
            sports-mad and passionate people to develop Ludimos for all
            cricketers across the globe.
            <br>
            <br>
            Ludimos is the world's first AI powered cricket coaching platform to
            help cricket organisations and coaches scout, nurture, develop and
            monitor the progress of cricketers in real time using
            <b>ONE</b> simple, smart and synchronised platform.
          </p>

          <h2>Our vision</h2>
          <p>
            Make Cricket a truly global sport by increasing engagemnt and
            participation of cricket players through advanced technology.
          </p>
          <br>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <div class="team-member">
                <div class="image-container">
                  <img
                    src="../assets/img/madan.jpg"
                    class="image-rounded img-fluid"
                    alt="Team member Madan Raj Rajagopal"
                  >
                </div>

                <div class="name">
                  Madan Raj Rajagopal
                </div>
                <div class="function">
                  CEO | AI | ML
                </div>
                <div class="links">
                  <a
                    href="https://www.linkedin.com/in/madanraj/"
                    target="_blank"
                  >Linkedin</a>
                  <a href="mailto:madan@ludimos.com">Email me</a>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <div class="team-member">
                <div class="image-container">
                  <img
                    src="../assets/img/said.jpg"
                    class="image-rounded img-fluid"
                    alt="Ludimos team"
                  >
                </div>

                <div class="name">
                  Said Zadou
                </div>
                <div class="function">
                  CPO | UI & UX Design | Frontend
                </div>
                <div class="links">
                  <a
                    href="https://www.linkedin.com/in/said-zadou-a6984823/"
                    target="_blank"
                  >Linkedin</a>
                  <a href="mailto:said@ludimos.com">Email me</a>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="team-member">
                <div class="image-container">
                  <img
                    src="../assets/img/roberto.jpg"
                    class="image-rounded img-fluid"
                    alt="Ludimos team"
                  >
                </div>
                <div class="name">
                  Roberto Frontado
                </div>
                <div class="function">
                  CTO | Fullstack Developer
                </div>
                <div class="links">
                  <a
                    href="https://www.linkedin.com/in/robertofrontado/"
                    target="_blank"
                  >Linkedin</a>
                  <a href="mailto:hello@ludimos.com">Email me</a>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="team-member">
                <div class="image-container">
                  <img
                    src="../assets/img/matt.jpg"
                    class="image-rounded img-fluid"
                    alt="Ludimos team"
                  >
                </div>
                <div class="name">
                  Matt Blakeley
                </div>
                <div class="function">
                  Head of Sales & Marketing
                </div>
                <div class="links">
                  <a
                    href="https://www.linkedin.com/in/mattblakeley/"
                    target="_blank"
                  >Linkedin</a>
                  <a href="mailto:karl@ludimos.com">Email me</a>
                </div>
              </div>
            </div>
          </div>
          <h2>Our advisors</h2>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <div class="team-member">
                <div class="image-container">
                  <img
                    src="../assets/img/abhijit-khan-germany.jpg"
                    class="image-rounded img-fluid"
                    alt="Ludimos team"
                  >
                </div>
                <div class="name">
                  Abhijit Khan
                </div>
                <div class="function">
                  Head Coach, German Cricket Academy & German U19 National Team
                </div>
                <div class="links">
                  <a
                    href="https://www.linkedin.com/in/abhijit-khan-7244131b6/"
                    target="_blank"
                  >Linkedin</a>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="team-member">
                <div class="image-container">
                  <img
                    src="../assets/img/frank-van-rest.jpg"
                    class="image-rounded img-fluid"
                    alt="Ludimos team"
                  >
                </div>
                <div class="name">
                  Frank van Rest
                </div>
                <div class="function">
                  Business advisor <br>
                  Ex-CTO, Learnbeat
                </div>
                <div class="links">
                  <a
                    href="https://www.linkedin.com/in/fwvanrest/"
                    target="_blank"
                  >Linkedin</a>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="team-member">
                <div class="image-container">
                  <img
                    src="../assets/img/kailash.jpg"
                    class="image-rounded img-fluid"
                    alt="Ludimos team"
                  >
                </div>
                <div class="name">
                  Kailash Chandrasekaran
                </div>
                <div class="function">
                  B2C Consultant
                </div>
                <div class="links">
                  <a
                    href="https://www.linkedin.com/in/kailashchandrasekaran/"
                    target="_blank"
                  >Linkedin</a>
                </div>
              </div>
            </div>
          </div>
          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "About",
  mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "ViewContent",
      category: "Menu",
      action: "Menu",
      label: "About",
      type: "About",
    });
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - About`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
<style lang="scss" scoped>
.team-member {
  text-align: center;
  margin: 0 0 50px;
  padding: 0 30px 0 0;
  .image-container {
    position: relative;
    margin: 30px 0;
    img {
      max-width: 200px;
      + img {
        opacity: 0;
        position: absolute;
        top: 0;
        right: 0;
        transition: all 0.3s ease;
      }
    }
  }

  &:hover {
    .image-container {
      img + img {
        opacity: 1;
        top: -20px;
        right: 20px;
      }
    }
  }
  .name {
    font-weight: 600;
    font-size: 18px;
  }
  .function {
    font-size: 14px;
    opacity: 0.5;
  }
  .story {
    font-size: 14px;
    margin-top: 10px;
  }
  .links {
    font-size: 14px;
    margin-top: 10px;

    a {
      margin-right: 10px;
      margin-left: 0;
    }
  }
}
</style>
